import styled from "@emotion/styled";

export const Container = styled.div``;

export const LinkContainer = styled.div``;
